'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _header = require('../actions/header');

var HeaderActions = _interopRequireWildcard(_header);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case HeaderActions.INIT_HEADER:
            return action.headerInfo;

        case HeaderActions.UPDATE_CLASS_HEADER:
            return Object.assign({}, state, { classes: action.classHeader.classes });

        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/shared/reducers/header.js
// module id = 775
// module chunks = 0